/*
 * @Author: Teemo Ding
 * @Date: 2021-09-16 10:24:06
 * @LastEditTime: 2022-06-02 11:23:13
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelDomain/Edit/DNSRecordRecommendation/index.tsx
 */
import { Alert, Button } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Icon } from '@/src/tools/icon';
import {
  EnumStatus,
  DNSErrorCodes,
  DistributionStatus,
  SSLMODE,
  ACMEStatus,
  ACMEErrorCodes,
  SSLErrorCodes,
} from '@/src/types/common/domain';
import { Collapse } from 'antd';
import React, { useState } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  i18nGet,
  handleOnGetCurrentSCTimezone,
  handleOnFormatCurrentSCTimeAndDateWithTimezone,
} from 'src/tools/tools';
import css from '../css.module.less';
import { Modal, ModalFooter } from '@/src/components/Antd';
import { CopyText } from '@/src/components/CopyText';
import moment from 'moment';

const { Panel } = Collapse;

const DNSRecordRecommendation = ({
  domain,
  domainStatus,
  awsDistributionDomainName,
  certificate,
  verifyDomain,
  refreshTxtRecord,
  verifiedDate,
  success,
  errorCode,
  errorMsg,
  distributionStatus,
  btnDisableWhileReq,
  resubmitted,
  sslMode,
  cNameTtl,
  acme,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [fold, setFold] = useState(false);
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [isAlertVisible, setIsAlertVisible] = useState(true);
  const { status: certificateStatus = '' } = certificate || {};
  const wwwRegex = new RegExp(/^www\./);
  const wwwDomain = wwwRegex.test(domain);
  const domainLength = (domain || '').split('.').length - 1;
  // const rootDomain = domainLength == 1;
  const subDomain = domainLength >= 2;
  const disabledAll =
    (sslMode === SSLMODE.BYO && !certificateStatus) || !domain || !sslMode;
  const deletingStatus = domainStatus === EnumStatus.Deleting;

  //ACME
  const {
    acmeStatus,
    acmeErrorCode,
    dnsChallengeRecord,
    dnsChallengeValue,
    dnsTtl,
    acmeOrderExpiresAt,
  } = acme || {};

  const isACMEMode = sslMode === SSLMODE.ACME;
  const isBYOMode = sslMode === SSLMODE.BYO;

  const isACMECompleted =
    sslMode === SSLMODE.ACME && acmeStatus === ACMEStatus.VALID && verifiedDate;
  const isBYOCompleted = sslMode === SSLMODE.BYO && verifiedDate;

  //txt Record Expired time Valid
  const timezone = handleOnGetCurrentSCTimezone();
  const currentMoment = moment.tz(timezone);
  const expireMoment = moment.utc(acmeOrderExpiresAt).tz(timezone);
  const isACMETimeExpired = currentMoment.isAfter(expireMoment);

  const disableVerify =
    isACMEMode &&
    (isACMETimeExpired ||
      acmeStatus === ACMEStatus.PROCESSING ||
      acmeStatus === ACMEStatus.VALID);

  const renderAlert = (statusItem, success, errorCode, errorMsg) => {
    const noDnsError =
      errorCode === 0 &&
      (!DNSErrorCodes.includes(errorCode) ||
        (!SSLErrorCodes.includes(errorCode) && isACMEMode) ||
        !ACMEErrorCodes.includes(acmeErrorCode));

    // BYO 场景：Pending 且无错误
    const isPendingWithNoError =
      !isACMEMode &&
      statusItem === EnumStatus.Pending &&
      noDnsError &&
      distributionStatus === DistributionStatus.Creating &&
      !resubmitted;

    // ACME: Cloudfront 与 DNS 均未完成
    const isACMEAllUnfinished =
      isACMEMode &&
      acmeStatus === ACMEStatus.PENDING &&
      distributionStatus === DistributionStatus.Creating &&
      noDnsError;

    // ACME: Cloudfront 完成，用户未点击 Verify
    const isACMEOnlyDistribution =
      isACMEMode &&
      acmeStatus === ACMEStatus.PENDING &&
      (distributionStatus === DistributionStatus.Created ||
        distributionStatus === DistributionStatus.Creating) &&
      noDnsError;

    // ACME: Cloudfront 完成，用户已点击 Verify
    const isACMEAllFinished =
      isACMEMode &&
      acmeStatus === ACMEStatus.PROCESSING &&
      (distributionStatus === DistributionStatus.Created ||
        distributionStatus === DistributionStatus.Creating) &&
      noDnsError;

    const isInfoType =
      isPendingWithNoError ||
      isACMEAllUnfinished ||
      isACMEOnlyDistribution ||
      isACMEAllFinished;

    //通用错误：适用于ACME和BYO的DNS错误处理
    const isGeneralError =
      !success && DNSErrorCodes.includes(errorCode) && isAlertVisible;
    //ACME证书错误：根据需求需展示在此组件 UXPSA-14200
    const isACMEWithSSLError =
      !success &&
      isACMEMode &&
      SSLErrorCodes.includes(errorCode) &&
      isAlertVisible;
    //ACME流程错误
    const isACMEError =
      (ACMEErrorCodes.includes(acmeErrorCode) ||
        acmeStatus === ACMEStatus.INVALID) &&
      isAlertVisible;

    // 是否展示 alert
    const shouldShowAlert =
      isPendingWithNoError ||
      isInfoType ||
      isGeneralError ||
      isACMEError ||
      isACMEWithSSLError;

    if (!shouldShowAlert) return null;

    const message = isInfoType
      ? isACMEAllUnfinished || isACMEOnlyDistribution
        ? getI18n('salesChannelDomainAndStatus.edit.dNSVerificationReminder')
        : getI18n(
            'salesChannelDomainAndStatus.edit.domainVerificationProcessing',
          )
      : getI18n('salesChannelDomainAndStatus.edit.domainVerificationFailed');

    const getDescInfo = () => {
      if (isInfoType) {
        if (isPendingWithNoError)
          return getI18n('salesChannelDomainAndStatus.edit.statusItemPending');
        if (isACMEAllUnfinished)
          return getI18n('salesChannelDomainAndStatus.edit.aCMEAllUnfinished');
        if (isACMEOnlyDistribution)
          return getI18n(
            'salesChannelDomainAndStatus.edit.aCMEOnlyDistribution',
          );
        if (isACMEAllFinished)
          return getI18n('salesChannelDomainAndStatus.edit.aCMEAllFinished');
      } else if (isGeneralError || isACMEWithSSLError) {
        return (
          <>
            {getI18n('salesChannelDomainAndStatus.edit.statusItemnotPending')}

            {!success &&
              (DNSErrorCodes.includes(errorCode) ||
                (SSLErrorCodes.includes(errorCode) && isACMEMode)) && (
                <>
                  {getI18n('salesChannelDomainAndStatus.edit.failedReason')}
                  {getI18n(`salesChannelDomainAndStatus.error.${errorCode}`)}
                  {errorMsg ? `: ${errorMsg}` : ''}
                </>
              )}
          </>
        );
      } else if (sslMode === SSLMODE.ACME && isACMEError) {
        return (
          <>
            {getI18n('salesChannelDomainAndStatus.edit.statusItemnotPending')}
            <br />
            {ACMEErrorCodes.includes(acmeErrorCode) && (
              <>
                {getI18n('salesChannelDomainAndStatus.edit.failedReason')}
                {getI18n(`salesChannelDomainAndStatus.error.${acmeErrorCode}`)}
                {/* {errorMsg ? `: ${errorMsg}` : ''} */}
              </>
            )}
          </>
        );
      }
    };

    return (
      <Alert
        className={css.certificateAlert}
        closable={!isInfoType}
        onClose={() => setIsAlertVisible(false)}
        message={message}
        showIcon
        type={isInfoType ? 'info' : 'error'}
        icon={<Icon type={isInfoType ? 'iconpending' : 'iconfailed'} />}
        description={getDescInfo()}
      />
    );
  };

  const renderItem = (
    <div>
      {renderAlert(domainStatus, success, errorCode, errorMsg)}
      <p className={css.recordRecommendation}>
        {getI18n('salesChannelDomainAndStatus.edit.recordRecommendation')}
      </p>
      {!domain && (
        <p>
          {getI18n('salesChannelDomainAndStatus.edit.nodomaincertificatetips')}
        </p>
      )}
      {!!domain && (wwwDomain || subDomain) && (
        <>
          {/*  CName Record */}
          <div>
            <p className={css.wwwDomainTitle}>
              {getI18n('salesChannelDomainAndStatus.edit.updateCNAMEof')}{' '}
            </p>
            {sslMode && ((certificate && isBYOMode) || isACMEMode) && (
              <div className={css.cNameContainer}>
                <p className={css.recordContainer}>
                  <span className={css.recordTitle}>
                    {getI18n('salesChannelDomainAndStatus.edit.name')}:{' '}
                  </span>
                  <CopyText text={domain} />
                </p>
                <p className={css.recordContainer}>
                  <span className={css.recordTitle}>
                    {getI18n('salesChannelDomainAndStatus.edit.content')}:{' '}
                  </span>
                  <CopyText text={awsDistributionDomainName} />
                </p>
                <p style={{ marginBottom: 0 }}>
                  <span className={css.recordTitle}>TTL: </span>
                  <CopyText
                    text={'60'}
                    otherText={getI18n(
                      'salesChannelDomainAndStatus.edit.ttldesc',
                    )}
                  />
                </p>
              </div>
            )}
          </div>
          {/*  TXT Record */}
          {sslMode === SSLMODE.ACME && (
            <div className={css.txtContainer}>
              <p className={css.wwwDomainTitle}>
                {getI18n('salesChannelDomainAndStatus.edit.txtrecordtitle')}{' '}
              </p>
              <p className={css.recordContainer}>
                <span className={css.recordTitle}>
                  {getI18n('salesChannelDomainAndStatus.edit.name')}:{' '}
                </span>
                <CopyText text={dnsChallengeRecord} />
              </p>
              <p className={css.recordContainer}>
                <span className={css.recordTitle}>
                  {getI18n('salesChannelDomainAndStatus.edit.content')}:{' '}
                </span>
                <CopyText text={dnsChallengeValue} />
              </p>
              <p className={css.recordContainer}>
                <span className={css.recordTitle}>TTL: </span>
                <CopyText
                  text={dnsTtl}
                  otherText={getI18n(
                    'salesChannelDomainAndStatus.edit.ttldesc',
                  )}
                />
              </p>
              <p className={css.recordContainer}>
                <span className={css.recordTitle}>
                  {getI18n(
                    'salesChannelDomainAndStatus.edit.recordExpirationTime',
                  )}
                  :{' '}
                </span>
                <span>
                  {handleOnFormatCurrentSCTimeAndDateWithTimezone(
                    acmeOrderExpiresAt,
                  )}
                </span>
              </p>
              <div className={css.nav}>
                <Icon type='iconinfo2' className={css.info} />
                <span className={css.navTips}>
                  {getI18n('salesChannelDomainAndStatus.edit.refreshTip1')}
                  <span
                    className={
                      isACMEMode && isACMETimeExpired
                        ? css.txtRefresh
                        : css.txtRefreshDisabled
                    }
                    onClick={async () => {
                      if (isACMEMode && isACMETimeExpired) {
                        await refreshTxtRecord();
                      }
                    }}
                    role='button'
                    style={{
                      cursor:
                        isACMEMode && isACMETimeExpired
                          ? 'pointer'
                          : 'not-allowed',
                    }}>
                    {getI18n('salesChannelDomainAndStatus.edit.refreshTip2')}
                  </span>{' '}
                  {getI18n('salesChannelDomainAndStatus.edit.refreshTip3')}
                </span>
              </div>
            </div>
          )}

          {!awsDistributionDomainName ? (
            <p className={css.awsDistributionDomainName}>
              {getI18n('salesChannelDomainAndStatus.edit.getCNAMEdetailstips')}
            </p>
          ) : (
            <></>
          )}
        </>
      )}
      {/* remove root domain and IPConfig UXPSA-12917 */}
      {!!domain && (
        <div className={css.rootTips}>
          {getI18n('salesChannelDomainAndStatus.edit.rootdomainTips')}
        </div>
      )}
      <Button
        type='primary'
        disabled={
          disabledAll || deletingStatus || btnDisableWhileReq || disableVerify
        }
        onClick={() => {
          setShowVerifyModal(true);
        }}
        className={css.primaryButton}>
        {getI18n('salesChannelDomainAndStatus.edit.verifyConnection')}
      </Button>
    </div>
  );
  return (
    <>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={css.containerClassName}
        titleOnClick={() => setFold(!fold)}
        rightPart={<Icon type={fold ? 'icondown1' : 'iconright'}></Icon>}
        hideContent={!fold}
        title={getI18n(
          'salesChannelDomainAndStatus.edit.dNSRecordRecommendation',
        )}>
        {(isACMECompleted || isBYOCompleted) && (
          <div className={css.certificateVerified}>
            <p className={css.certificateTitle}>
              {getI18n('salesChannelDomainAndStatus.edit.connectionVerified')}
            </p>
            <p className={css.verifiedData}>
              {getI18n('salesChannelDomainAndStatus.edit.verifiedon')}{' '}
              {verifiedDate || ''}
            </p>
          </div>
        )}
        {isACMECompleted || isBYOCompleted ? (
          <Collapse className={css.collapse} ghost>
            <Panel
              key='1'
              header={getI18n(
                'salesChannelDomainAndStatus.edit.dNSSettingsInstruction',
              )}>
              {renderItem}
            </Panel>
          </Collapse>
        ) : (
          renderItem
        )}
      </SectionWrapper>
      {showVerifyModal && (
        <Modal
          width={600}
          visible={showVerifyModal}
          onCancel={() => {
            setShowVerifyModal(false);
          }}
          title={getI18n('salesChannelDomainAndStatus.edit.verifyConnection')}>
          <div className={css.verifyModal}>
            {getI18n('salesChannelDomainAndStatus.edit.verifyConnectionModal')}
          </div>
          <ModalFooter
            onCancel={() => {
              setShowVerifyModal(false);
            }}
            okText={getI18n('general.antd.Modal.ModalFooter.confirm')}
            onOk={async () => {
              await verifyDomain();
              setShowVerifyModal(false);
              setIsAlertVisible(true);
            }}
          />
        </Modal>
      )}
    </>
  );
};

export default DNSRecordRecommendation;
